<template>
    <v-container fluid>
        <confirm-modal
          :dialog="showConfirm"
          :message="confirmMessage"
          @confirm="confirmResponse($event)">
        </confirm-modal>

        <loader :show="$anyLoading()" :message="messageLoader"></loader>

        <!-- breadcrumb, header -->
        <v-layout row wrap>
            <v-flex md10 offset-md1 xs12 offset-xs0 mb-2>
              <div class="mt-2">
                <span class="green--text">Torneos</span>
                <span class="ml-3 mr-3">></span>
                <span>Nuevo Torneo</span>
                <span class="ml-3 mr-3">></span>
                <span>Captura de Resultados</span>
              </div>

              <div class="layout row wrap mt-2 calendar-header">
                <h4 class="subheading mb-0 pr-3">Es necesario que agregues equipos a los partidos.</h4>

                <v-btn color="green"
                  class="ml-auto"
                  @click="submit"
                  v-if="currentTournament.status != 'finalized'">
                  Guardar Cambios
                </v-btn>
              </div>
            </v-flex>
        </v-layout>

        <!-- add actions dial -->
        <v-speed-dial v-model="fab"
          direction="top"
          :fixed="true"
          v-bind:class="{ 'open': fab }">
            <!-- dial activator -->
            <v-btn slot="activator"
              v-model="fab"
              color="green"
              dark
              fab>
              <v-icon>add</v-icon>
              <v-icon>close</v-icon>
            </v-btn>

            <!-- Slots de juego -->
            <v-btn v-if="true"
              fab
              dark
              small
              color="pink"
              @click="slotDialog = true"
              :disabled="currentTournament.status === 'finalized'"
              data-label="Slots de juego"
              class="label-left">
              <v-icon>event</v-icon>
            </v-btn>

            <!-- Todos contra todos -->
            <v-btn v-if="false"
              fab
              dark
              small
              color="pink"
              @click="showAddTeam = true"
              :disabled="currentTournament.status === 'finalized'"
              data-label="Todos contra todos"
              class="label-left">
              <v-icon>flash_on</v-icon>
            </v-btn>

            <!-- Agregar jornada -->
            <v-btn fab
              dark
              small
              color="pink"
              @click="showNewRound = true"
              :disabled="currentTournament.status === 'finalized'"
              data-label="Agregar jornada"
              class="label-left">
              <v-icon>add</v-icon>
            </v-btn>

            <!-- Agregar juego -->
            <v-btn v-if="currentSet != null"
              fab
              dark
              small
              color="green"
              @click="openNewGameModal()"
              :disabled="currentTournament.status === 'finalized'"
              data-label="Agregar juego"
              class="label-left">
              <v-icon>add</v-icon>
            </v-btn>
        </v-speed-dial>

        <v-layout row class="calendar">
            <!-- main content -->
            <v-flex md10 offset-md1 xs12 offset-xs0>
                <h5 class="green--text">Calendario del torneo</h5>

                <p class="subheading">Jornadas</p>

                <v-tabs v-model="selectedtab">
                    <v-tabs-bar class="transparent" left>
                      <v-tabs-slider color="green"></v-tabs-slider>
                      <v-tabs-item
                          v-cloak
                          v-for="(set, i) in sets"
                          :key="i"
                          :href="'#set' + i">

                          <div @click="setCurrentSet(set)">
                              <p class="subheading mb-0">{{ setTabHeading(set,i) }}</p>
                              <span>{{ set.type }}</span>
                          </div>
                      </v-tabs-item>
                    </v-tabs-bar>

                    <v-tabs-items>
                        <v-tabs-content
                            v-for="(set, i) in sets"
                            :key="i"
                            :id="'set' + i">

                            <div class="text-xs-center mt-3">
                              <v-btn @click="removeSet(set,i)"
                                color="error"
                                class="white--text">
                                  Borrar jornada
                                <v-icon >delete</v-icon>
                              </v-btn>
                            </div>

                            <div class="matches-wrapper">
                              <p class="subheading mt-3 mb-2">Partidos</p>

                              <v-card class="match" v-for="(match, i) in set.matches" :key="match.id">
                                <!-- delete match button -->
                                <span>
                                  <v-btn @click="removeMatch(match,set)"
                                    color="red"
                                    dark
                                    small
                                    fab>
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </span>

                                <!-- TEAM-A -->
                                <div class="match-team team-a" v-if="match.teamA">
                                  <p class="match-team__label">
                                    <!-- remove team button -->
                                    <v-btn v-if="currentTournament.status != 'finalized'"
                                      flat
                                      icon
                                      color="red"
                                      :disabled="currentTournament.status === 'finalized'"
                                      @click="removeTeamFromMatch(match,'A')">
                                      <v-icon>remove</v-icon>
                                    </v-btn>

                                    <!-- team name -->
                                    <span class="crop-text">
                                      {{ match.teamA.name }} {{currentTournament.mode == 'groups' ? ' - '+match.teamA.groupName : '' }}
                                    </span>
                                  </p>

                                  <!-- team image -->
                                  <div class="match-team__img"
                                    :style="{'background': 'transparent url('+ match.teamA.image +') center/cover no-repeat'}"
                                    @click="openAddTeamModal('a', match)">
                                  </div>
                                </div>
                                <!-- no team-A -->
                                <div class="match-team team-a" v-if="!match.teamA">
                                  <v-text-field
                                    hide-details
                                    label="Alias"
                                    solo
                                    v-model="match.team_a_alias"
                                    maxlength="20"
                                    color="green">
                                  </v-text-field>

                                  <v-tooltip top>
                                    <v-btn :disabled="currentTournament.status === 'finalized'"
                                      class="ma-0"
                                      flat
                                      icon
                                      color="white"
                                      slot="activator"
                                      @click="openAddTeamModal('a', match)">
                                      <v-icon>add</v-icon>
                                    </v-btn>

                                    <span>Agregar equipo</span>
                                  </v-tooltip>
                                </div>

                                <!-- MATCH SCORE -->
                                <div class="match-score">
                                  <span class="match-score__item">
                                    {{ match.teamAGoal != null ? match.teamAGoal : '-' }}
                                  </span>
                                  <span class="match-score__divider">:</span>
                                  <span class="match-score__item">
                                    {{ match.teamBGoal != null ? match.teamBGoal : '-' }}
                                  </span>
                                </div>

                                <!-- TEAM-B -->
                                <div class="match-team team-b" v-if="match.teamB">
                                  <!-- team image -->
                                  <div class="match-team__img"
                                    :style="{'background': 'transparent url('+ match.teamB.image +') center/cover no-repeat'}"
                                    @click="openAddTeamModal('b', match)">
                                  </div>

                                  <p class="match-team__label">
                                    <!-- team name -->
                                    <span class="crop-text">
                                      {{ match.teamB.name }} {{currentTournament.mode == 'groups' ? ' - '+match.teamB.groupName : '' }}
                                    </span>

                                    <!-- remove team button -->
                                    <v-btn v-if="currentTournament.status != 'finalized'"
                                      flat
                                      icon
                                      color="red"
                                      :disabled="currentTournament.status === 'finalized'"
                                      @click="removeTeamFromMatch(match,'B')">
                                      <v-icon>remove</v-icon>
                                    </v-btn>
                                  </p>
                                </div>
                                <!-- no team-B -->
                                <div class="match-team team-b" v-if="!match.teamB">
                                  <v-tooltip top>
                                    <v-btn :disabled="currentTournament.status === 'finalized'"
                                      class="ma-0"
                                      flat
                                      icon
                                      color="white"
                                      slot="activator"
                                      @click="openAddTeamModal('b', match)">
                                      <v-icon>add</v-icon>
                                    </v-btn>

                                    <span>Agregar equipo</span>
                                  </v-tooltip>

                                  <v-text-field
                                    hide-details
                                    label="Alias"
                                    solo
                                    v-model="match.team_b_alias"
                                    maxlength="20"
                                    color="green">
                                  </v-text-field>
                                </div>

                                <div class="match-footer">
                                  <!-- MATCH ADDRESS -->
                                  <v-tooltip top>
                                    <p class="match-address"
                                      slot="activator">
                                      <v-icon class="mr-1">location_on</v-icon>
                                      <span class="green--text">{{ currentTournament.is_femexfut ? '' : match.court.name }}</span>
                                    </p>
                                    <span>{{ currentTournament.is_femexfut ? '' : match.court.address }}</span>
                                  </v-tooltip>

                                  <!-- MATCH DATE -->
                                  <p class="match-date ma-0">
                                    <v-icon class="mr-1">event</v-icon>
                                    {{ match.date }}

                                    <v-btn :disabled="currentTournament.status === 'finalized'"
                                      @click="showNewGameForEdit(match)"
                                      class="ml-1 edit-icon-calendar"
                                      flat
                                      icon>
                                      <v-icon>edit</v-icon>
                                    </v-btn>
                                  </p>
                                </div>
                              </v-card>
                            </div>
                        </v-tabs-content>
                    </v-tabs-items>
                </v-tabs>

                <footer class="calendar-footer">
                  <v-tooltip top>
                    <v-checkbox slot="activator"
                      :label="`Notificar a usuarios`"
                      :hide-details="true"
                      v-model="notify">
                    </v-checkbox>
                    <span>Al seleccionar estarás notificando a los jugadores de este torneo sobre cambios en su calendario</span>
                  </v-tooltip>

                  <div class="mt-3">
                    <v-btn @click="cancel" flat color="red" v-if="currentTournament.status != 'finalized'">
                      Cancelar
                    </v-btn>
                    <v-btn color="green" @click="submit" v-if="currentTournament.status != 'finalized'">
                      Guardar Cambios
                    </v-btn>
                  </div>
                </footer>
            </v-flex>

            <!-- previous code left panel -->
            <!-- <v-flex xs10 sm3 offset-xs1>
                <v-container fluid pl-0 pr-0>
                    <v-layout row wrap>
                        <v-flex xs12 v-if="true">
                            <v-btn
                                fab
                                color="pink"
                                dark
                                @click="slotDialog = true"
                                :disabled="currentTournament.status === 'finalized'">
                                <v-icon>event</v-icon>
                            </v-btn>
                            <span>Slots de juego</span>
                        </v-flex>

                        <v-flex xs12 v-if="false">
                            <v-btn
                                fab
                                color="pink"
                                dark
                                @click="showAddTeam = true"
                                :disabled="currentTournament.status === 'finalized'">
                                <v-icon>flash_on</v-icon>
                            </v-btn>
                            <span>Todos contra todos</span>
                        </v-flex>

                        <v-flex xs12>
                            <v-btn
                                fab
                                color="pink"
                                dark
                                @click="showNewRound = true"
                                :disabled="currentTournament.status === 'finalized'">
                                <v-icon>add</v-icon>
                            </v-btn>
                            <span>Agregar jornada</span>
                        </v-flex>

                        <v-flex xs-12 v-if="currentSet != null">
                          <v-btn dark
                              fab
                              color="green"
                              @click="openNewGameModal()"
                              :disabled="currentTournament.status === 'finalized'">
                              <v-icon>add</v-icon>
                          </v-btn>
                          <span>Agregar juego</span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex> -->

            <!-- <v-card class="mb-32px" v-for="(match, i) in set.matches" :key="match.id">
              <v-card-text>
                <v-btn
                  color="red"
                  @click="removeMatch(match,set)"
                  dark
                  small
                  absolute
                  top
                  right
                  fab
                >
                  <v-icon>delete</v-icon>

                </v-btn>


                  <v-container fluid class="pb-0">
                      <v-layout row wrap>
                          <div class="d-flex card-information">
                              <v-tooltip top>
                                <div slot="activator" class="flex-align-center">
                                  <v-icon class="mr-2">location_on</v-icon>
                                  <span class="green--text subheading">{{match.court.name}}</span>
                                </div>
                                <span>{{match.court.address}}</span>
                              </v-tooltip>

                              <div class="flex-align-center">
                                <v-icon class="mr-2">event</v-icon>
                                <span class="subheading">{{ dayFormatForMatch(match.date) }}</span>
                              </div>

                              <v-btn flat
                                class="edit-button"
                                  icon
                                  @click="showNewGameForEdit(match)"
                                  :disabled="currentTournament.status === 'finalized'">
                                  <v-icon>create</v-icon>
                              </v-btn>
                          </div> -->
                          <!-- <v-flex xs12 text-xs-left mb-1>
                              <v-icon class="mr-2">location_on</v-icon>
                              <span v-if="match.court" class="green--text subheading">{{match.court.name}}</span>
                              <span v-if="match.court" class="subheading">{{match.court.address}}</span>
                          </v-flex>
                          <v-flex xs12 text-xs-left>
                              <v-icon class="mr-2">event</v-icon>
                              <span class="subheading">{{ dayFormatForMatch(match.date) }}</span>
                              <v-btn

                                  flat
                                  icon
                                  @click="showNewGameForEdit(match)"
                                  :disabled="currentTournament.status === 'finalized'">
                                  <v-icon>create</v-icon>
                              </v-btn>
                          </v-flex> -->
                      <!-- </v-layout>
                      <v-layout row wrap>
                          <v-flex
                              v-if="match.teamA"
                              xs12
                              sm5
                              class="team-square relative"
                              subheading
                              pt-2>
                              <div
                                  class="fab-img"
                                  :style="{'background-image': 'url('+ match.teamA.image +')', 'cursor': 'pointer' }"
                                  @click="openAddTeamModal('a', match)"
                              ></div>
                              <span class="mt-2">{{ match.teamA.name }} {{currentTournament.mode == 'groups' ? ' - '+match.teamA.groupName : ''}}</span>
                              <span v-if="currentTournament.status != 'finalized'" class="top-right" @click="removeTeamFromMatch(match,'A')">
                                <v-btn
                                    flat
                                    icon
                                    color="red"
                                    :disabled="currentTournament.status === 'finalized'">
                                    <v-icon>remove</v-icon>
                                </v-btn></span>
                          </v-flex>
                          <v-flex  v-if="!match.teamA" xs12 sm5 class="team-square" subheading>
                              Agregar Equipo
                              <v-btn
                                  flat
                                  icon
                                  color="white"
                                  @click="openAddTeamModal('a', match)"
                                  :disabled="currentTournament.status === 'finalized'">
                                  <v-icon>add</v-icon>
                              </v-btn>
                              <v-text-field
                                class="d-block"
                                label="Alias"
                                v-model="match.team_a_alias"
                                maxlength="20"
                                color="green"
                              ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm2 d-flex align-center justify-center headline>
                            <span class="score-text">
                              {{match.teamAGoal != null ? match.teamAGoal : '-'}}
                            </span>
                              <span >
                                VS
                              </span>
                              <span class="score-text">
                                {{match.teamBGoal != null ? match.teamBGoal : '-'}}
                              </span>
                          </v-flex>

                          <v-flex
                              v-if="match.teamB"
                              xs12
                              sm5
                              class="team-square relative"
                              subheading

                              pt-2>
                              <div
                                  mt-2
                                  class="fab-img"
                                  @click="openAddTeamModal('b', match)"
                                  :style="{'background-image': 'url('+ match.teamB.image +')', 'cursor': 'pointer' }"
                              ></div>
                              <span class="pt-2">{{ match.teamB.name }} {{currentTournament.mode == 'groups' ? ' - '+match.teamB.groupName : ''}}</span>
                              <span v-if="currentTournament.status != 'finalized'" class="top-right" @click="removeTeamFromMatch(match,'B')">
                                <v-btn
                                    flat
                                    icon
                                    color="red"
                                    :disabled="currentTournament.status === 'finalized'">
                                    <v-icon>remove</v-icon>
                                </v-btn>
                              </span>
                          </v-flex>
                          <v-flex v-if="!match.teamB" xs12 sm5 class="team-square" subheading>
                              Agregar Equipo
                              <v-btn
                                  flat
                                  icon
                                  color="white"
                                  @click="openAddTeamModal('b', match)"
                                  :disabled="currentTournament.status === 'finalized'">
                                  <v-icon>add</v-icon>
                              </v-btn>
                              <v-text-field
                                label="Alias"
                                class="d-block"
                                v-model="match.team_b_alias"
                                maxlength="20"
                                color="green"
                              ></v-text-field>
                          </v-flex>
                      </v-layout>
                  </v-container>
              </v-card-text>
            </v-card> -->
        </v-layout>
        <new-round-modal :dialog="showNewRound"
            @response="addNewRoundResponse($event)"
            @cancel="closeModal($event)"
            :typesSelected="typesOfRoundSelected">
        </new-round-modal>

        <new-game-modal :tournament="currentTournament.id"
            :dialog="showNewGame"
            :allmatches = "allMatches"
            :fields="currentFields"
            :match="selectedMatch"
            :error="newGameError"
            :gameForEdit="gameForEdit"
            :femexfut="currentTournament.is_femexfut"
            @response="addNewGame($event)"
            @cancel="closeModal($event)">
        </new-game-modal>

        <add-team-modal v-if="currentSet"
            :matches="currentSet.matches"
            :match="currentMatch"
            :letter="teamLetter"
            :teams="currentTournamentTeams"
            :dialog="showAddTeam"
            @response="teamSelected($event)"
            @cancel="showAddTeam = false"
            class="hola">
          </add-team-modal>

          <slot-generator-modal
            :dialog="slotDialog"
            :sets = "sets"
            :periodicity = "currentTournament.periodicity"
            @response="slotsDialogResponse($event)">
          </slot-generator-modal>
    </v-container>
</template>

<script>
import NewRoundModal from './NewRoundModal'
import NewGameModal from './NewGameModal'
import AddTeamModal from './AddTeamModal'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import Match from '@/models/match'
import SlotGeneratorModal from './SlotGeneratorModal'

export default {
    name: 'TournamentCalendar',
    components: {
        NewRoundModal,
        NewGameModal,
        AddTeamModal,
        SlotGeneratorModal
    },
    data() {
        return {
          selectedtab:null,
            fab: false,
            notify:false,
            showConfirm: false,
            confirmMessage:"",
            confirmType:"",
            messageLoader: 'Cargando Información',
            newGameDate: moment().format('YYYY-MM-DD'),
            currentSet: null,
            setToDelete:null,
            matchToDelete:null,
            showNewRound: false,
            showNewGame: false,
            showAddTeam: false,
            teamLetter: '',
            currentMatch: null,
            newGameError: '',
            gameForEdit: false,
            slotDialog: false,
            months: {
                'January': 'Enero',
                'February': 'Febrero',
                'March': 'Marzo',
                'April': 'Abril',
                'May': 'Mayo',
                'June': 'Junio',
                'July': 'Julio',
                'August': 'Agosto',
                'September': 'Septiembre',
                'October': 'Octubre',
                'November': 'Noviembre',
                'December': 'Diciembre'
            },
            selectedTeams: [],
            teamsToSelect: [],
            typesOfRoundSelected: [],
            selectedMatch: null
        }
    },
    created() {
        if(this.$route.params.tournamentID) {
            this.findTournament(this.$route.params.tournamentID)
            this.loadTournamentTeams(this.$route.params.tournamentID)
            this.loadFields()
            //this.loadTorunamentTeams(this.currentTournament)
            //this.loadTeams()
        }
    },
    computed: {
        ...mapGetters([
            'currentTournament',
            'currentTeams',
            'currentTournamentTeams',
            'currentFields'
        ]),
        sets() {
            return this.currentTournament.sets
        },
        allMatches(){
          var matches = []
          for(let i = 0; i < this.currentTournament.sets.length; i++){
            let set = this.currentTournament.sets[i]
            for(let z = 0; z < set.matches.length; z++){
              matches.push(set.matches[z])
            }
          }
          return matches
        }
    },
    watch: {
        currentTournamentTeams(teams) {
            this.mixinMatchesCourtsTeams()
        },
        currentTournament(tournament) {
            this.mixinMatchesCourtsTeams()
        },
        currentFields(fields){
          this.mixinMatchesCourtsTeams()
        }

    },
    methods: {
        ...mapActions([
            'findTournament',
            'loadTeams',
            'updateSets',
            'loadTournamentTeams',
            'loadFields',
            'updateTournamentCalendar',
            'calendarIsEdited'
        ]),
        closeModal(modal) {
            switch(modal) {
                case 'newgamemodal':
                    this.newGameError = ''
                    this.showNewGame = false
                    this.selectedMatch = null
                    break;
                case 'newroundmodal':
                this.showNewRound = false;
                    break;
            }
        },
        addNewRoundResponse(data) {
            if(data){
                data.date = data.round === 'regular' ? this.getLastRoundDate() : data.date
                if(data.round != 'regular') this.typesOfRoundSelected.push(data.roundName)

                this.sets.push({
                    created_at: null,
                    id: null,
                    matches: [],
                    number: null,
                    start_date: data.date,
                    tournament_id: this.$route.params.tournamentID,
                    type: data.roundName || data.round,
                    updated_at: null
                })
                this.calendarIsEdited(true)
            }

            this.currentTournament.sets = this.orderSets()
            this.showNewRound = false
        },
        orderSets() {
            let tempSets = []
            let extraSets = []

            this.sets.forEach(set => {
                if(set.type === 'regular') {
                    tempSets.push(set)
                } else {
                    extraSets.push(set)
                }
            })

            extraSets = this.orderExtraSets(extraSets)
            extraSets.forEach(set => {
                tempSets.push(set)
            })

            return tempSets
        },
        orderExtraSets(extraSets) {
            let tempExtraSets = extraSets.slice()
            let firstPosition = 0

            tempExtraSets.forEach((set, j) => {
                firstPosition = this.getExtraSetPosition(set.type)
                for(let i = 0, x = tempExtraSets.length; i < x; i++) {
                    if(firstPosition > this.getExtraSetPosition(tempExtraSets[i].type)) {
                        [tempExtraSets[j], tempExtraSets[i]] = [tempExtraSets[i], tempExtraSets[j]]
                    }
                }
            })

            return tempExtraSets

        },
        getExtraSetPosition(extraSetName) {
            let position = 0

            switch(extraSetName) {
                case '1/16':
                    position = 5
                    break;
                case '1/8':
                    position = 4
                    break;
                case '1/4':
                    position = 3
                    break;
                case 'semi':
                    position = 2
                    break;
                case 'final':
                    position = 1
                    break;
            }

            return position
        },
        getLastRoundDate() {
            let lastDate

            if(this.sets.length === 0) return moment().format('YYYY-MM-DD')

            this.sets.forEach((set, i) => {
                lastDate = set.type === 'regular' ? set.start_date : lastDate
            })

            return moment(lastDate).add(this.currentTournament.periodicity, 'day').format('YYYY-MM-DD')
        },
        addNewGame(game) {
          //console.log("RESPONSE",data)
          this.calendarIsEdited(true)
          console.log('game', game)
          if(game){
            this.currentSet.matches.push(game)
          }
          this.showNewGame = false
            /*if(data.response) {
                let positionToExclude = data.data.gamePosition
                if(this.checkDateAvailability(data.data, positionToExclude)){
                    this.newGameError = ''
                    this.showNewGame = false
                    data.successCallback()
                    if(positionToExclude == null) {
                        this.sets[this.currentSet].matches.push({
                            id: null,
                            date: data.data.datetime,
                            duration: data.data.gameTime,
                            team_a: null,
                            team_b: null,
                            court_id: 12,
                            set_id: this.sets[this.currentSet].id,
                            created_at: null,
                            updated_at: null
                        })
                    } else {
                        this.sets[this.currentSet].matches[positionToExclude] = {
                            id: null,
                            date: data.data.datetime,
                            duration: data.data.gameTime,
                            team_a: null,
                            team_b: null,
                            court_id: 12,
                            set_id: this.sets[this.currentSet].id,
                            created_at: null,
                            updated_at: null
                        }
                    }
                } else {
                    this.newGameError = 'Ya existe otro partido agendado a la misma hora'
                }
            }*/
        },
        showNewGameForEdit(match) {
            //this.gameForEdit = { position: i, game: this.sets[this.currentSet].matches[i] }
            this.selectedMatch = match
            this.gameForEdit = true
            this.showNewGame = true
        },
        openNewGameModal() {

          const lastMatch = this.currentSet.matches[this.currentSet.matches.length - 1];
          this.selectedMatch = new Match()
          this.selectedMatch.date = lastMatch ? lastMatch.date : undefined // new Date(this.currentSet.start_date)
          this.selectedMatch.court = lastMatch ? lastMatch.court : null
          this.selectedMatch.courtID = lastMatch ? lastMatch.courtID : null
          this.selectedMatch.duration = lastMatch ? lastMatch.duration : null
          this.gameForEdit = false
          this.showNewGame = true
        },
        teamSelected(data) {


        },
        removeMatch(match,set){
          this.matchToDelete = match
          this.showConfirm = true
          this.confirmMessage = "¿Está seguro de borrar el partido?"
          this.confirmType = "match"
        },
        removeSet(set,i){
          this.setToDelete = i
          this.showConfirm = true
          this.confirmMessage = "¿Está seguro de borrar la jornada?"
          this.confirmType = "set"
        },
        confirmResponse(response){
          this.showConfirm = false
          if(response){
            this.calendarIsEdited(true)
            if(this.confirmType == "match"){

              this.currentSet.matches.splice(this.currentSet.matches.indexOf(this.matchToDelete),1)
            }else if(this.confirmType == "set"){

              var newCurrentSetIndex = null
              if(this.sets.length == 1){
                this.currentSet = null
                this.selectedtab = null
              }else{
                newCurrentSetIndex = this.sets.length - 1 == this.setToDelete ? this.setToDelete -1 : this.setToDelete+1
                this.currentSet = this.sets[newCurrentSetIndex]
                //this.selectedtab = "set"+newCurrentSetIndex
              }

              this.sets.splice(this.setToDelete,1)
            }
          }
        },
        dayFormat(date) {
          var localLocale = moment(date);
          moment.locale('es');
          localLocale.locale(false);
          return localLocale.format('DD MMM').toUpperCase()
        },
        dayFormatForMatch(date) {
            var localLocale = moment(date);
            moment.locale('es');
            localLocale.locale(false);
            return localLocale.format('MMMM DD [del] YYYY [a] hh:mm a')
        },
        setCurrentSet(set){
          this.currentSet = set
        },
        setCurrentSetPosition(i) {
            /*if(!this.teamsToSelect[i]) this.teamsToSelect[i] = this.currentAssociatedTeams

            this.currentSet = i
            this.newGameDate = this.currentTournament.sets[this.currentSet].start_date*/
        },
        openAddTeamModal(letter, match) {
            if(this.currentTournament.status != 'finalized') {
                this.teamLetter = letter
                this.currentMatch = match
                this.showAddTeam = true
            }
        },
        mixinMatchesCourtsTeams(){
          if(this.currentTournament && this.currentTournamentTeams && this.currentFields){
            for(var i in this.currentTournament.sets){
              let set = this.currentTournament.sets[i]
              for(var m in set.matches){
                var match = set.matches[m]
                match.court = this.findObjByID( this.currentFields,match.courtID)
                match.teamA = this.findObjByID( this.currentTournamentTeams,match.teamAId)
                match.teamB = this.findObjByID( this.currentTournamentTeams,match.teamBId)
                // console.log("matches",match.teamA, match.teamB )
              }
            }
            if(this.currentSet){
              this.currentSet = this.findObjByID(this.sets,this.currentSet.id)
            }
            this.currentSet = this.currentSet == null ? this.sets[0] : this.currentSet

          }
        },
        findObjByID(array,id){
          for(var i in array){
            if(array[i].id == id){
              return array[i]
            }
          }
          return null
        },
        removeTeamFromMatch(match,which){
          this.calendarIsEdited(true)
          if(which == "A"){
            match.teamA = null
          }else{
            match.teamB = null
          }
        },
        setTabHeading(set,index){
          index+=1
          if(set.type == "regular"){
            return "Jornada "+index
          }else{
            return this.dayFormat(set.start_date)
          }
        },
        submit() {
            console.log("SAVE", this.currentTournament)
            this.currentTournament.notify = this.notify
            //this.messageLoader = 'Guardando Cambios...'
            this.updateTournamentCalendar(this.currentTournament)
            this.notify = false
            //this.updateSets({ sets: this.sets, tournamentID: this.$route.params.tournamentID })
        },
        cancel(){
          this.findTournament(this.currentTournament.id)
        },
        slotsDialogResponse(response){
          this.slotDialog = false
          console.log("RESPONSE",response)
        }
    }
}
</script>

<style lang="css" scoped>
/* general calendar */
.calendar {
  align-items: flex-start;
}

.calendar-header {
  align-items: center;
}

.calendar-header .subheading {
  line-height: 1.35;
}

@media screen and (max-width: 600px) {
  .calendar-header .subheading {
    width: 100%;
  }

  .calendar-header .btn {
    margin: 15px 0 10px;
  }
}

.calendar-footer {
  text-align: right;
  padding-bottom : 40px;
}

.calendar-footer .tooltip {
  display: inline-block;
  min-width: 190px;
}

.edit-icon-calendar .material-icons {
    font-size: 18px;
}


/* helpers */
.ml-auto {
  margin-left: auto;
}

.flex-align-center {
  display: flex;
  align-items: center;
}


/* speed-dial */
.speed-dial {
  bottom: 50px;
  right: 15px;
  z-index: 99;
}

.speed-dial >>> .btn[data-label]::after {
  content: attr(data-label);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
}

.speed-dial >>> .btn.label-left::after {
  right: calc(100% + 10px);
}

/* wrappers */
.matches-wrapper,
.calendar-footer {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_calendar/TournamentCalendar.vue